var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrarySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.70312C4.34315 4.70312 3 6.04627 3 7.70312C3 9.35998 4.34315 10.7031 6 10.7031C7.65685 10.7031 9 9.35998 9 7.70312C9 6.04627 7.65685 4.70312 6 4.70312ZM4 7.70312C4 6.59856 4.89543 5.70312 6 5.70312C7.10457 5.70312 8 6.59856 8 7.70312C8 8.80769 7.10457 9.70312 6 9.70312C4.89543 9.70312 4 8.80769 4 7.70312Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.7031C3.22386 11.7031 3 11.927 3 12.2031C3 12.4793 3.22386 12.7031 3.5 12.7031H8.5C8.77614 12.7031 9 12.4793 9 12.2031C9 11.927 8.77614 11.7031 8.5 11.7031H3.5Z",
    fill: "#5C5E69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23167 1.47917C0.518436 1.60885 0 2.23005 0 2.95498V13.9058C0 14.3504 0.191283 14.7434 0.490826 15.0156C0.857493 15.4368 1.39765 15.7031 2 15.7031H10C11.1046 15.7031 12 14.8077 12 13.7031V3.70312C12 2.96284 11.5978 2.31647 11 1.97064V1.50043C11 0.564576 10.1524 -0.142783 9.23167 0.0246275L1.23167 1.47917ZM2 2.70312H10C10.5523 2.70312 11 3.15084 11 3.70312V13.7031C11 14.2554 10.5523 14.7031 10 14.7031H2C1.44772 14.7031 1 14.2554 1 13.7031V3.70313C1 3.15084 1.44772 2.70312 2 2.70312Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrarySvg);
export default __webpack_public_path__ + "static/media/library-svg.bb733bc0f0f3d9277779c2ad78fb28ff.svg";
export { ForwardRef as ReactComponent };